import styled from 'styled-components'
import { Button } from 'syf-component-library/ui/atoms'

export const MenuItem = styled.li`
  padding: 10px 25px;
`

export const MenuLink = styled(Button)`
  display: inline;
  margin: 0;
  padding: 0;
`

export const HeaderMenuText = styled.span`
  color: ${({ theme }): string => theme.header.text};
  font-weight: normal;
`
